import { lazyUpdateUserConfigurationService } from 'owa-session-store';
import { Feature, runOwsRequestWithMonitor } from '../../../shared';
import { getServiceAsync } from '../../../service';

/**
 * Persists data to PeopleHubOptions in owa user configuration.
 *
 * Relies on reducers updating states which should be persisted to be
 * updated before function is called.
 */
export function persistPeopleHubOptions(peopleHubOptionsString: string): Promise<void> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'PersistPeopleHubOptions',
            feature: Feature.PersistData,
            operation: () =>
                lazyUpdateUserConfigurationService.importAndExecute(
                    [
                        {
                            key: 'PeopleHubOptions',
                            valuetype: 'String',
                            value: [peopleHubOptionsString],
                        },
                    ],
                    'OWA.ViewStateConfiguration'
                ),
            transformResponse: () => {
                /*return nothing*/
            },
        })
    );
}
